<template>
  <div class="breadcumb-warp wh-radius-card wh-contain">
    <span v-show="haveTop" class="have-top">当前位置：</span>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item, index) in curList" :key="index" :to="item.to || ''">
        <span
          :class="{'active-item': item.code}"
          @click="codeFn(item.code)"
        >{{ item.name }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'WhBreadcumb',
  props: {
    haveTop: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      curList: []
    }
  },
  watch: {
    list: {
      handler(newV, oldV) {
        this.curList = [...this.list]
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    codeFn(code) {
      if (code) {
        this.$emit('code', code)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .breadcumb-warp{
    /*margin-top: 15px;*/
    padding: 22px 50px;
    user-select: none;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    color: #606266;
  }
  .have-top{
    line-height: 1;
  }
  .active-item{
    font-weight: bold;
    color: #303133;
    cursor: pointer;
    &:hover{
      color: rgb(64, 158, 255)
    }
  }
</style>
